import { render } from "./비뇨의학과.vue?vue&type=template&id=e9bbadac"
import script from "./비뇨의학과.vue?vue&type=script&lang=js"
export * from "./비뇨의학과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__